// This change is done to solve an a11y issue with the fluid collab space https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/113890/
// This is a temporary fix while we work on stopping the event getting propagated from the ActionMenu which is part of the host-ux. We should remove this code
// once the fix is deployed.
// TODO: WI https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/119558
export function isEventFromContextMenu(ev?: React.MouseEvent | React.KeyboardEvent) {
    const eventTarget = ev?.target ? (ev.target as HTMLElement) : null;
    if (eventTarget?.className?.indexOf('ms-ContextualMenu') > -1) {
        return true;
    }
    return false;
}
